import { socketClient } from 'pages/views/devices/socketClient';
import {
  PRINTER_FORMATS,
  PRINTER_KINDS,
  PRINTER_MESSAGES,
} from 'pages/views/devices/socketClient/types';
import { onUserActivity } from 'root/merchantos/activity';

import { showSurvey } from './survey';

window.postMessageHandler = function postMessageHandler(event) {
  const whitelist = [
    '.rad.localdev',
    '.rad1.localdev',
    '.lightspeedappdev.com',
    '.lightspeedappstaging.com',
    '.lightspeedappstg.com',
    '.lightspeedapp.com',
    '.merchantos.com',
  ];

  function isDomainWhitelisted(domain: TSFixMe) {
    return whitelist.some((d) => domain.endsWith(d));
  }

  if (!isDomainWhitelisted(event.origin)) {
    return;
  }
  if (
    typeof event.data === 'object' &&
    !!event.data.type &&
    (!('payload' in event.data) || typeof event.data.payload === 'object')
  ) {
    switch (event.data.type) {
      case 'pageRouterGoTo':
        window.PageRouter.goTo(event.data.payload.url);
        break;
      case 'navigateToContent':
        window.navigateToContent(
          event.data.payload.type,
          event.data.payload.name,
          event.data.payload.params
        );
        break;
      case 'openUrl':
        window.merchantos.utils.openUrl(event.data.payload.url, event.data.payload.target);
        break;
      case 'routeChange':
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
        history.replaceState(null, null, event.data.payload.url);
        break;
      case 'updateBreadcrumbs':
        window.merchantos.asyncSubscribe.notifySubscribers('react.mount.topbar', {
          props: {
            crumbs: event.data.payload.crumbs,
          },
        });
        break;
      case 'notification':
        window.flashNotifier(
          event.data.payload.type,
          event.data.payload.message,
          event.data.payload.seconds
        );
        break;
      case 'updateDocumentTitle':
        window.document.title = event.data.payload.title;
        break;
      case 'notifyUserActivity':
        onUserActivity();
        break;
      case 'removeSelf':
        const iframes = document.getElementsByTagName('iframe');

        // This code fragment finds the iframe associated with the message and deletes it.
        // See https://stackoverflow.com/a/20404180 for more information.
        for (let i = 0; i < iframes.length; i += 1) {
          if (
            iframes[i].contentWindow === event.source ||
            // @ts-expect-error: invalid source typing.
            iframes[i].contentWindow === event.source?.parent
          ) {
            iframes[i].remove();
            break;
          }
        }
        break;
      case 'printTestLabel':
        socketClient.send(PRINTER_MESSAGES.PRINT, {
          data: event.data.payload.zpl,
          kind: PRINTER_KINDS.LABEL,
          size: event.data.payload.size,
          format: PRINTER_FORMATS.ZPL,
          executionTimes: {
            RETAIL_PRINT_START: Date.now(),
          },
        });
        break;
      case 'printTestReceipt':
        window.merchantos.print.printUrl({
          url: '',
          target: '_blank',
          pageType: 'receipt',
          srcdoc: event.data.payload.html,
        });
        break;
      case 'showSurvey':
        showSurvey(event.data.payload.surveyType);
        break;
      default:
        break;
    }
  }
};

if (window.addEventListener) {
  window.addEventListener('message', window.postMessageHandler, false);
}
